import { render, staticRenderFns } from "./ApplicationFieldCollection.vue?vue&type=template&id=b6b1781c&scoped=true&"
import script from "./ApplicationFieldCollection.vue?vue&type=script&lang=js&"
export * from "./ApplicationFieldCollection.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationFieldCollection.vue?vue&type=style&index=0&id=b6b1781c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b1781c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
